export default __webpack_public_path__ + "images/0x5f7cbcb391d33988dad74d6fd683aadda1123e4d.png";